<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/status-error.svg?raw'
export default {
  name: 'IconStatusError',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
